<template>
	<div class="to-be-confirmed">
		<div class="box teal">
			<van-cell center is-link to="/receivingAddressPick">
				<!-- 使用 title 插槽来自定义标题 -->
				<template #title>
					<div class="van-address-item__name">{{ addressInfo.name }}</div>
					<div class="van-address-item__address">{{ addressInfo.address }}</div>
				</template>
			</van-cell>
		</div>
		<div class="box" v-for="(item, index) in list" :key="index">
			<div class="header">
				<van-checkbox v-model="selectAllVendor[index]" @click="toggleAllVendor(index)">
					<van-icon name="shop-o"/>
				</van-checkbox>
				<span>{{ item.vendorName }}</span>
			</div>
			<van-checkbox-group v-model="checkedIds[index]" :ref="el => checkboxGroupRefs[index] = el">
				<van-cell-group :border="false">
					<van-cell
							v-for="(book, idx) in item.books"
							clickable
							:key="idx"
					>
						<template #icon>
							<van-checkbox
									:name="book.id"
									@click.stop
							/>
						</template>
						<template #title>
							<div class="book-item" v-if="book.pdaBook">
								<div class="cover">
									<img v-if="book.pdaBook.coverUrl" :src="book.pdaBook.coverUrl" :key="book.pdaBook.bookId"
                       referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
									<img v-else :src="defaultCover()" :key="book.pdaBook.bookId"/>
								</div>
								<div class="right">
									<router-link class="title" :to="'/orderBookDetail/' + book.pdaBook.bookId">{{
											book.pdaBook.title
										}}
									</router-link>
									<p>{{ book.pdaBook.author }}</p>
									<p>{{ book.pdaBook.publisher + '/' + book.pdaBook.publicationDate }}</p>
									<p>
										<span class="price">￥{{ book.pdaBook.price }}</span>
<!--										<span class="stock">库存:{{ book.pdaBook.inventory }}</span>-->
									</p>
								</div>
							</div>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
		</div>
	</div>
	<van-action-bar>
    <div class="left">
      <van-checkbox v-model="selectAll" @click="toggleAll">全选</van-checkbox>
      <span class="van-submit-bar__price">
        ¥<span class="van-submit-bar__price-integer">{{ allPrice }}</span>
      </span>
    </div>
		<van-action-bar-button type="warning" text="删除所选" @click="delSelected"/>
		<van-action-bar-button type="danger" text="确认提交" @click="onSubmit"/>
	</van-action-bar>
	<van-overlay :show="loading">
		<div class="submit-message">
			<div class="wrapper">
				<van-loading size="40px" vertical color="#38b1a7">提交中...</van-loading>
			</div>
		</div>
	</van-overlay>
</template>

<script>
import {defineComponent, ref, onMounted, watch, computed} from 'vue';
import {Dialog, Toast} from 'vant';
import {getConsignee, getConfirmCarts} from '@/api/users';
import {getConsigneeById} from '@/api/consignees';
import {isNotEmpty, randomBookCover, setCoversCart} from '@/utils/util';
import {delCartBook} from '@/api/carts';
import store from '@/store';
import {submitOrder} from '@/api/orders';
import {useRouter} from "vue-router";

export default defineComponent({
	name: 'ToBeConfirmed',
	setup() {
		const addressId = computed(() => {
			return store.state.addressId;
		});
		const uid = computed(() => {
			return store.state.reader.user.uid;
		});
		const router = useRouter();
		const addressInfo = ref({}); // 用于显示的地址信息
		let addressAll = {}; // 所有的地址信息
		const loading = ref(false);
		
		// 各个供应商选择组件
		const checkboxGroupRefs = ref([]);
		// 当前选中图书的id  二维数组
		const checkedIds = ref([]);
		// 供应商是否全选 数组
		const selectAllVendor = ref([]);
		// 是否全选
		const selectAll = ref(false);
		// 购物车数据  {vendorName:string,books:[]}
		const list = ref([]);
		// 合计的价格
		const allPrice = ref(0);
		// 获取待确认订单
		const onConfirmCarts = (flag) => {
			list.value = [];
			allPrice.value = 0;
			getConfirmCarts()
					.then(data => {
						if (isNotEmpty(data)) {
							const isbns = [];
							const data1 = [];
							for (let key in data) {
								data1.push({vendorName: key, books: data[key]});
								data[key].forEach(item => {
									if (isNotEmpty(item.pdaBook)) {
										isbns.push(item.pdaBook.isbn);
									}
								})
							}
							if (isNotEmpty(isbns)) {
								setCoversCart(isbns, data1);
							}
							data1.forEach((item, index) => {
								checkedIds.value[index] = [];
								selectAllVendor.value[index] = false;
							});
							list.value = data1;
						} else {
							list.value = [];
							checkedIds.value = [];
							if (flag) {
								router.push({path: '/personalCenter'});
							}
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 获取优先收货地址
		const onConsignee = () => {
			getConsignee()
					.then(data => {
						if (isNotEmpty(data)) {
							addressAll = data;
							let consigneeAddress = {};
							if (isNotEmpty(data.consigneeAddress)) {
								consigneeAddress = JSON.parse(data.consigneeAddress);
							}
							addressInfo.value = {
								name: data.consignee + '  ' + data.consigneePhone,
								address: consigneeAddress.province + consigneeAddress.city + consigneeAddress.area + consigneeAddress.detail
							};
						} else {
							addressAll = {};
							Dialog.confirm({
								title: '用户暂无收货地址,去设置',
							})
									.then(() => {
										router.push({path: '/receivingAddressEdit'});
									})
									.catch(() => {
									});
						}
					})
					.catch((error) => {
						console.error(error);
            addressAll = {};
            Dialog.confirm({
              title: '用户暂无收货地址,去设置',
            })
                .then(() => {
                  router.push({path: '/receivingAddressEdit'});
                })
                .catch(() => {
                });
					});
		};
		// 根据id获取单个收货地址
		const onConsigneeById = (id) => {
			getConsigneeById(id)
					.then(data => {
						if (isNotEmpty(data)) {
							addressAll = data;
							let consigneeAddress = {};
							if (isNotEmpty(data.consigneeAddress)) {
								consigneeAddress = JSON.parse(data.consigneeAddress);
							}
							addressInfo.value = {
								name: data.consignee + '  ' + data.consigneePhone,
								address: consigneeAddress.province + consigneeAddress.city + consigneeAddress.area + consigneeAddress.detail
							};
						} else {
							addressAll = {};
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 供应商全选
		const toggleAllVendor = (index) => {
			selectAllVendor.value[index] = selectAllVendor.value[index];
			checkboxGroupRefs.value[index].toggleAll(selectAllVendor.value[index]);
		};
		// 全选
		const toggleAll = () => {
			checkboxGroupRefs.value.forEach((el, index) => {
				el.toggleAll(selectAll.value);
				selectAllVendor.value[index] = selectAll.value;
			});
		};
		// 删除所选
		const delSelected = () => {
			// 是否选择了数据
			const flag = checkedIds.value.some(ids => isNotEmpty(ids));
			if (flag) {
				Dialog.confirm({
					title: '删除订单',
					message: '确认删除订单',
				})
						.then(() => {
							let param = ''
							checkedIds.value.forEach((item,index) => {
								item.forEach(id => {
									const book= list.value[index].books.find(book1 => book1.id === id);
									if(book){
										if (isNotEmpty(param)) {
											param = param + ',' + book.bookNo
										} else {
											param = book.bookNo;
										}
									}
								})
							});
							if (!isNotEmpty(param)) param = param.slice(0, param.length - 1);
							delCartBook(param)
									.then(data => {
										if (data === null) {
											onConfirmCarts(true);
											checkedIds.value = [];
											Toast({message: '删除成功'});
										}
									})
									.catch((error) => {
										console.error(error);
									});
						})
						.catch(() => {
						});
			} else {
				Toast({message: '请先选择图书'});
			}
		};
		// 提交订单
		const onSubmit = () => {
			if (isNotEmpty(addressAll)) {
				// 是否选择了数据
				const flag = checkedIds.value.some(ids => isNotEmpty(ids));
				if (flag) {
					Dialog.confirm({
						title: '确认收货地址',
						message: addressInfo.value.name+'\n'+addressInfo.value.address,
					})
							.then(() => {
								formData();
							})
							.catch(() => {
							});
				} else {
					Toast({message: '请先选择图书'});
				}
			} else {
				Toast({message: '请先设置地址'});
			}
		};
		const formData = () => {
			let address = {};
			if (isNotEmpty(addressAll.consigneeAddress)) {
				address = JSON.parse(addressAll.consigneeAddress);
			}
			const consigneeAddress = address.province + address.city + address.area + address.detail;
			const consigneeDetailed = {
				"province": address.province,
				"city": address.city,
				"area": address.area,
				"detail": address.detail,
				"postCode": addressAll.consigneePostcode
			};
			const deliveryInfo = {
				'method': 'delivery',
				'consignee': addressAll.consignee,
				'consigneePhone': addressAll.consigneePhone,
				'consigneePostcode': addressAll.consigneePostcode,
				'consigneeAddress': consigneeAddress,
				'consigneeDetailed': JSON.stringify(consigneeDetailed)
			};
			// 订单详细信息
			let json = [];
			checkedIds.value.forEach(item => {
				item.forEach(id => {
					json.push({'cartId': id});
				})
			});
			const orderData = {
				'deliveryInfo': deliveryInfo,
				'extraInfo': {
					'cartIds': json,
					'uid': uid.value.toString()
				}
			};
			loading.value = true;
			submitOrder(orderData)
					.then(data => {
						if (data) {
							Toast({message: data});
							checkedIds.value = [];
							onConfirmCarts(true);
						}
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => loading.value = false)
			
		};
		watch(
				checkedIds, () => {
					// 各供应商的全选状态
					checkedIds.value.forEach((ids, index) => selectAllVendor.value[index] = ids.length === list.value[index].books.length);
					// 是否选择了数据  全选状态 选择项 总计价格
					const flag = checkedIds.value.some(ids => isNotEmpty(ids));
					if (flag) {
						allPrice.value = 0;
						checkedIds.value.forEach((ids, index) => {
							ids.forEach(id => {
								const book = list.value[index].books.find(iBook => iBook.id === id);
								if (book) {
									allPrice.value += book.pdaBook.price;
								}
							})
						})
						allPrice.value = allPrice.value.toFixed(1);
						selectAll.value = !selectAllVendor.value.some(b => !b);
					} else {
						selectAll.value = false;
						allPrice.value = 0;
					}
				}, {immediate: true, deep: true},
		);
		onMounted(() => {
			onConfirmCarts(false);
			if (addressId.value !== '') {
				onConsigneeById(addressId.value);
			} else {
				onConsignee();
			}
		});
		
		function handleErrorImage(event) {
			event.srcElement.src = randomBookCover();
		}
		
		function defaultCover() {
			return randomBookCover();
		}
		
		return {
			addressInfo,
			list,
			allPrice,
			delSelected,
			checkedIds,
			checkboxGroupRefs,
			onSubmit,
			loading,
			handleErrorImage,
			defaultCover,
			toggleAllVendor,
			toggleAll,
			selectAll,
			selectAllVendor
		};
	},
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/book.less";
@import "../assets/css/address.less";
@import "../assets/css/submit-message.less";
.to-be-confirmed {
	padding-bottom: 100px;
}
</style>
